import React from 'react';
import Navbar  from "./Navbar";
import "./style.css";
export const Header = () => {
  return (
    <div id='main'>
      <Navbar/>
      <div className='name'>
        <h1><span>launch your app</span>with confidence</h1>
        <p className='details'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Praesentium voluptates aliquam temporibus necessitatibus quae asperiores, cupiditate, fugiat iste corrupti,
         officiis aut ipsa autem fuga tenetur possimus esse ipsam. Rerum, minus?</p>
      </div>
    </div>
  )

}
export default Header;
